/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc
 */

export const getPaymentMethodUpdateRequestUrlRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'getPaymentMethodUpdateRequestUrl',
  auth: 'external',
  fingerprint: 'PiJIK432hM5hq52i6TP_9LYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getInvoicePaymentInfoRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'getInvoicePaymentInfo',
  auth: 'external',
  fingerprint: 'sYSLt-37xwNJzKJvzO4kSLYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getReceiptEmailRecipientsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'getReceiptEmailRecipients',
  auth: 'external',
  fingerprint: 'NHYXB59Xo0m6NSIi7Y_Cg7YD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const resendReceiptEmailRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'resendReceiptEmail',
  auth: 'external',
  fingerprint: 'Mrns2pOdicIFC8kTedeYsbYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cancelSubscriptionRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'cancelSubscription',
  auth: 'external',
  fingerprint: 'NLkvHhly5QmRDoANIloaIrYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deletePaymentMethodRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicBillingActionsRpc',
  rpcName: 'deletePaymentMethod',
  auth: 'external',
  fingerprint: 'Qz3_yrfsgCT1AJ4y-K4sf7YD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};